import { Directive, ElementRef, EventEmitter, HostBinding, Injector, Input, Output, SimpleChanges } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
//import { Observable } from 'rxjs';
//import { ISelectedPosition } from '../../../site/conditionMonitoring/condition-monitoring.service';

@Directive({
    selector: 'oc-thumbnail'
})
export class OcThumbnailDirective extends UpgradeComponent {
    @Input() readOnly: boolean;
    @Input() ngModel: IFile;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('ocThumbnail', elementRef, injector);
    }
}